<div class="input-group mt2">
  <input class="form-control" [value]="inputData" attr.placeholder="{{ placeholder | translate }}" autofocus (input)="onInputChange($event)" (keyup.enter)="performSearch()">
</div>
